import { NgModule } from '@angular/core';
import { PHBHPFeaturePackageSOPManagementComponent } from './ph-bhp-feature-package-sopmanagement.component';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PhBhpManageSOPComponent } from './ph-bhp-manage-sop/ph-bhp-manage-sop.component';
import { PhBhpSopComponent } from './ph-bhp-sop/ph-bhp-sop.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PhBhpSopStepComponent } from './ph-bhp-sop-step/ph-bhp-sop-step.component';
import { PhBhpViewSOPComponent } from './ph-bhp-view-sop/ph-bhp-view-sop.component';
import { PhBhpPreviewSOPComponent } from './ph-bhp-preview-sop/ph-bhp-preview-sop.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { TooltipModule as BsTooltipModule } from 'ngx-bootstrap/tooltip';
import { DynamicTranslationDialogComponent } from './dynamic-translation-dialog/dynamic-translation-dialog.component';
import { StepListComponent } from './ph-bhp-manage-sop/step-list/step-list.component';
import { InstitutionSelectionComponent } from './ph-bhp-manage-sop/institution-selection/institution-selection.component';
import { InstitutionSelectionCountriesComponent } from './ph-bhp-manage-sop/institution-selection-countries/institution-selection-countries.component';
import { StepEditorComponent } from './ph-bhp-manage-sop/step-editor/step-editor.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatListModule } from '@angular/material/list';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';
// common libraries


@NgModule({
    declarations: [PHBHPFeaturePackageSOPManagementComponent, PhBhpManageSOPComponent, PhBhpSopComponent, PhBhpSopStepComponent, PhBhpViewSOPComponent, PhBhpPreviewSOPComponent, DynamicTranslationDialogComponent, StepListComponent, InstitutionSelectionComponent, InstitutionSelectionCountriesComponent, StepEditorComponent],
    imports: [
        PHBHPLayoutPackageModule,
        CollapseModule,
        DragDropModule,
        PHBHPLocalizePackageModule,
        PDFExportModule,
        TabsModule.forRoot(),
        BsTooltipModule,
        PhBhpUiModule,
        MatIconModule,
        MatSelectModule,
        MatRadioModule,
        MatListModule,
        ClientLibModule,
        PhBhpFeatureComponentsModule
    ],
    exports: [PHBHPFeaturePackageSOPManagementComponent, PhBhpManageSOPComponent, PhBhpSopComponent, PhBhpSopStepComponent, PhBhpViewSOPComponent, PhBhpPreviewSOPComponent, DynamicTranslationDialogComponent, ClientLibModule]
})
export class PHBHPFeaturePackageSOPManagementModule { }
